import { getEnumValues } from './get-enum-values';
export enum OrganizationRole{
	Administrator='administrator',
	TeamAccess='team-admin',
	PlayerAccess='player-admin',
}
export const OrganizationRoleValues = getEnumValues<OrganizationRole>(OrganizationRole)